<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer [attr.role]="(clientInfoService.isHandsetObservable | async) ? 'dialog' : 'navigation'"
                 [mode]="'side'"
                 [opened]="(clientInfoService.isHandsetObservable | async) === false"
                 [position]="'end'"
                 class="sidenav">
        <mat-toolbar>Options</mat-toolbar>
        <!-- TODO: check if needed-->
        <!--&& !this.test.hideOptions"-->

        <ng-content select="burncase-quickview"></ng-content>
        <ng-content select="burncase-brush-settings"></ng-content>
        <div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <!--    <button-->
        <!--            type="button"-->
        <!--            aria-label="Toggle sidenav"-->
        <!--            mat-icon-button-->
        <!--            (click)="drawer.toggle()"-->
        <!--            *ngIf="isHandset$ | async">-->
        <!--      <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>-->
        <!--    </button>-->

        <ng-content select="burncase-navigation"></ng-content>
        <!-- Add Content Here -->
    </mat-sidenav-content>
</mat-sidenav-container>
